import React from 'react';
import cn from 'classnames';
import { GatsbyImage } from 'gatsby-plugin-image';
import DefaultHero from './DefaultHero';
import Content from './Content';
import { Icons, News } from 'components/Intro';
import { useLang } from 'utils/localisation';
import { getImagesWithArtDirection } from 'utils/images';

import * as styles from './Intro.module.scss';

export default function Intro({
  title,
  subtitle,
  button,
  video,
  icons,
  certificateIDs,
  imgAlt = '',
  contentMod = 'default',
  gatsbyImage,
}) {
  const isSsr = typeof window === 'undefined';
  const images = getImagesWithArtDirection(gatsbyImage);
  const lang = useLang();
  const showNews = lang === 'en' || lang === 'uk' || lang === 'kz' || lang === 'pl';
  const isDesktop = !isSsr && window.innerWidth > 1024;

  return (
    <section id="intro" className={styles.introWrapper}>
      <div className={styles.intro}>
        <GatsbyImage
          alt={imgAlt}
          image={images}
          className={styles.picture}
          imgClassName={styles.pictureImage}
          loading="eager"
        />
        {lang !== 'ae' && video && <DefaultHero video={video} isDesktop={isDesktop} />}
        <div className={cn(styles.content, styles[contentMod])}>
          <div className={styles.contentLayout}>
            <Content title={title} subtitle={subtitle} button={button} />
          </div>
          {(icons || certificateIDs) && (
            <Icons className={styles.mobileHidden} certificateIDs={certificateIDs} list={icons} />
          )}
        </div>
      </div>
      {showNews && <News className={styles.news} />}
    </section>
  );
}
